module.exports = __webpack_public_path__ + "bigi-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-types/assets/bigi-logo.png
// module id = 1119
// module chunks = 10